import React, { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import ReactGa from 'react-ga'
const App = React.lazy(() => import(/* webpackChunkName: "App" */ './App'));
Sentry.init({
  dsn: "https://cfd46b354dfd43ed9ad65228bdd7275e@o426639.ingest.sentry.io/6456146",
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
const Main = () => {
  useEffect(() => {
    ReactGa.initialize('UA-143030585-2');
    ReactGa.pageview(window.location.pathname + window.location.search)
  })
  return (
    <>
      {/* <FirebaseMessagingHandler /> */}
      <Provider store={configureStore()}>
        <Suspense fallback={<div className="loading" />}>
          <App />
        </Suspense>
      </Provider>
    </>
  );
};

ReactDOM.render(<Main />, document.getElementById('root'));

